/**
 * The keys cakephp sends next to an Adyen refusal (`errors[0].key`), and the translation each one
 * is shown with. A key the widget does not know keeps the generic, status-based text: keys are
 * added on the backend before the widgets have copy for them, never renamed.
 */
export const ADYEN_ERROR = {
  KEYS: {
    BOOKING_REFUSED: 'adyen.booking_refused',
    SESSION_ALREADY_USED: 'adyen.session_already_used',
    PAYMENT_UNAVAILABLE: 'adyen.payment_unavailable',
    RESCHEDULE_NOT_ALLOWED: 'adyen.reschedule_not_allowed',
    NOT_ENABLED_FOR_BOOKING: 'adyen.not_enabled_for_booking',
    /** The payment's session expired before /book: nothing was booked, any amount taken is refunded automatically. */
    SESSION_EXPIRED: 'adyen.session_expired',
  },
  /** Shown by the payment pane itself (cw-adyen), in the `adyen.errors` register. */
  PANE_MESSAGES: {
    UNAVAILABLE: 'adyen.errors.unavailable',
    TEMPORARILY_UNAVAILABLE: 'adyen.errors.temporarily_unavailable',
    RESCHEDULE_NOT_ALLOWED: 'adyen.errors.reschedule_not_allowed',
  },
  /** Shown on the summary after /book; the partner's courtesy form (`Sie` / `Du`) is appended. */
  BOOKING_MESSAGES: {
    BOOKING_REFUSED: 'payment_components.adyenBookingRefused',
    SESSION_SPENT: 'payment_components.paymentSessionSpentError',
    SESSION_EXPIRED: 'payment_components.paymentSessionExpiredError',
  },
  /** Info notices on the summary that quote the spent session (`{{transactionId}}`); courtesy form appended. */
  BOOKING_NOTICES: {
    SESSION_SPENT: 'payment_components.paymentSessionSpentNotice',
  },
  /**
   * A /book after an Adyen payment answered 423 (booking lock): another /book for the same slot holds
   * the lock - possibly this payment's own first attempt (a double submit, a reload racing the
   * original). cakephp does not refund on a lock and never releases it early: it expires after its
   * TTL (`BookingLock::create`, 10 s). So the SAME request is sent again at these offsets from the
   * first lock answer - the last one 2 s after the lock has certainly expired - and then books or
   * answers "already booked" for the request that won. Still locked after that, the customer is told
   * the booking is being completed; never offered a new payment.
   */
  BOOKING_LOCK: {
    TTL_MS: 10000,
    RESEND_AT_MS: [3000, 7000, 12000],
  },
} as const;
